import ListItemText from '@mui/material/ListItemText'
import withStyles from '@mui/styles/withStyles'

const CustomListItemText = withStyles((theme) => ({
  root: {},
  multiline: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'start',
      gap: '9px',
    },
    '& *': {
      whiteSpace: 'nowrap',
    },
  },
  primary: {
    ...theme.typography.caption,
    color: theme.palette.text.secondary,
  },
  secondary: {
    ...theme.typography.caption,
    color: theme.palette.text.tertiary,
  },
}))(ListItemText)

export default CustomListItemText
